module.exports = __webpack_public_path__ + "img/cgjz-6.f25d228f.jpg";